import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const Group = (props) => {
  const { className, ...rest } = props;
  const classes = clsx('custom-icon', className);

  return (
    <svg width="101" height="100" viewBox="0 0 101 100" fill="none" data-type="fill" xmlns="http://www.w3.org/2000/svg" className={classes} {...rest}>
      <path d="M50.1225 8.33334C27.1225 8.33334 8.45583 27 8.45583 50C8.45583 73 27.1225 91.6667 50.1225 91.6667C73.1225 91.6667 91.7892 73 91.7892 50C91.7892 27 73.1225 8.33334 50.1225 8.33334ZM33.4558 72.9167C27.7058 72.9167 23.0392 68.25 23.0392 62.5C23.0392 56.75 27.7058 52.0833 33.4558 52.0833C39.2058 52.0833 43.8725 56.75 43.8725 62.5C43.8725 68.25 39.2058 72.9167 33.4558 72.9167ZM39.7058 33.3333C39.7058 27.5833 44.3725 22.9167 50.1225 22.9167C55.8725 22.9167 60.5392 27.5833 60.5392 33.3333C60.5392 39.0833 55.8725 43.75 50.1225 43.75C44.3725 43.75 39.7058 39.0833 39.7058 33.3333ZM66.7892 72.9167C61.0392 72.9167 56.3725 68.25 56.3725 62.5C56.3725 56.75 61.0392 52.0833 66.7892 52.0833C72.5392 52.0833 77.2058 56.75 77.2058 62.5C77.2058 68.25 72.5392 72.9167 66.7892 72.9167Z" fill="inherit" />
    </svg>
  );
};

Group.defaultProps = {
  className: '',
};

Group.propTypes = {
  className: PropTypes.string,
};

export default Group;
